export const ValidSettingTermKeys = [
  'childBadgeTerms',
  'childRegistrationError',
  'childRegistrationTerms',
  'conventionInfo',
  'conventionTerms',
  'optOutIdentity',
  'privacy',
  'terms',
  'underageWarning',
  'vendor',
  'volunteerTerms',
  'loginAnnouncement',
  'hotelReservationTerms',
  'hotelReservationAnnouncement',
  'hotelClosedError',
] as const;

export type SettingTermKeys = (typeof ValidSettingTermKeys)[number];

/*
 * Stripe Identity verification requirements
 * required  = everywhere
 * optional = not on kiosk
 * none = not required
 */
export type IdentityVerification = 'none' | 'optional' | 'required';
